// ProjectCard.js
import {useContext} from 'react';
import { LanguageContext } from '../context/LanguageContext';
import { Link } from 'react-router-dom';


function ProjectCard({ project }) {
  console.log(project)
  const { language } = useContext(LanguageContext);
  
  return (
    // <div className="project-card">
    //   <h2>{project.title}</h2>
    //   <p>{project.description}</p>
    //   <p><strong>Tech Stack:</strong> {project.techStack.join(', ')}</p>
    //   <img src={project.cardImage} alt="cardImage"/>
    //   <Link to={`/project/${project.id}`} className="details-link">View Details</Link>
    // </div>



    <div className="card">

      <Link to={`/project/${project.id}`} className="details-link">

        <div className="card_head">
          <div><b>Nº</b>{project.id}</div>
          <div><b>Año</b>{project.year}</div>
          <div><b>{project.techStack.join(', ')}</b></div>
        </div>
        	<div className="card_title"><div>
          <b>{project[language].title}</b>
        </div>
        </div>
        <div className="card_img">
          <img src={project.cardImage} width="80%" alt={project[language].altCardImage} />
        </div>

        <div className="card_detail">
        {project[language].description}
        
          

        </div>
        <div className="card_footer">
          <b>{project[language].status}</b>
        </div>
      </Link>
    </div>

  );
}

export default ProjectCard;